module.exports = __webpack_public_path__ + "assets/img/vra-cricket.b3c76c75.png";